import "./IconCollection.css";
export { IconCollection };
/** Коллекция иконок */
const IconCollection =
{
  "arrow_left": "font_icon icon_arrow_left",
  "arrow_right": "font_icon icon_arrow_right",
  "attachment": "font_icon icon_attachment",
  "balance": "svg_icon icon_balance",
  "bell": "font_icon icon_bell",
  "book_open": "font_icon icon_book_open",
  "book_stack": "font_icon icon_book_stack",
  "calendar": "font_icon icon_calendar",
  "caret_down": "font_icon icon_caret_down",
  "caret_up": "font_icon icon_caret_up",
  "chat": "font_icon icon_chat",
  "check": "font_icon icon_check",
  "chevron_down": "font_icon icon_chevron_down",
  "chevron_left": "font_icon icon_chevron_left",
  "chevron_right": "font_icon icon_chevron_right",
  "clipboard_list": "font_icon icon_clipboard_list",
  "close_circle": "font_icon icon_close_circle",
  "close": "font_icon icon_close",
  "cloud_download": "font_icon icon_cloud_download",
  "copy": "font_icon icon_copy",
  "delete": "font_icon icon_delete",
  "dialog_question": "font_icon icon_dialog_question",
  "double_arrows": "svg_icon icon_double_arrows",
  "double_arrows_square": "svg_icon icon_double_arrows_square",
  "double_chevron_left": "font_icon icon_double_chevron_left",
  "download": "font_icon icon_download",
  "ellipsis": "font_icon icon_ellipsis",
  "enroll": "font_icon icon_enroll",
  "exit": "font_icon icon_exit",
  "exit_fullscreen": "font_icon icon_exit_fullscreen",
  "eye": "font_icon icon_eye",
  "eye_invisible": "font_icon icon_eye_invisible",
  "eye_visible": "font_icon icon_eye_visible",
  "file": "font_icon icon_file",
  "folder_open": "font_icon icon_folder_open",
  "friends": "font_icon icon_friends",
  "fullscreen": "font_icon icon_fullscreen",
  "gavel": "font_icon icon_gavel",
  "graph": "font_icon icon_graph",
  "grid": "font_icon icon_grid",
  "home": "font_icon icon_home",
  "info": "font_icon icon_info",
  "link": "font_icon icon_link",
  "loading": "font_icon icon_loading spin_icon",
  "menu": "font_icon icon_menu",
  "mic": "font_icon icon_mic",
  "money": "font_icon icon_money",
  "new_file": "font_icon icon_new_file",
  "next_date": "font_icon icon_next_date",
  "none": "font_icon icon_none",
  "odnoklassniki": "font_icon icon_odnoklassniki",
  "pause": "font_icon icon_pause",
  "paying": "font_icon icon_paying",
  "person": "font_icon icon_person",
  "play_circle": "font_icon icon_play_circle",
  "question": "font_icon icon_question",
  "ruble": "font_icon icon_ruble",
  "ruble_square": "svg_icon icon_ruble_square",
  "ru": "svg_icon icon_ru",
  "search": "font_icon icon_search",
  "sent": "font_icon icon_sent",
  "study": "font_icon icon_study",
  "survey": "font_icon icon_survey",
  "video_file": "font_icon icon_video_file",
  "video": "font_icon icon_video",
  "video_slash": "font_icon icon_video_slash",
  "vk": "font_icon icon_vk",
  "warn": "font_icon icon_warn",
};
